import BASEAPI from '@/api/dataBase.js';
// import tradeMixin from './../../../../../../mixin/tradeMixin';
export const formFields = (ctx) => {
  return [
    {
      name: '费用编号',
      prop: 'expenseNo',
      type: 'input',
      // disabled: true,
      disabled: true,
    },
    {
      name: '公司',
      prop: 'businessCompanyName',
      type: 'input',
      // disabled: true,
      disabled: true,
    },
    {
      name: '部门',
      prop: 'businessDepartmentName',
      type: 'input',
      // disabled: true,
      disabled: true,
    },
    // {
    //   prop: 'settlementCompanyNo',
    //   name: '公司',
    //   type: 'select',
    //   options: ctx.companyList,
    //   value: 'personCompanyCode',
    //   label: 'personCompanyName',
    //   changeMethod: ctx.changeCompanyHandler,
    //   disabled: true,
    // },
    // {
    //   prop: 'settlementDepartmentNo',
    //   name: '部门',
    //   type: 'select',
    //   disabled: true,
    //   options: ctx.departmentList,
    //   value: 'personDepartmentCode',
    //   label: 'personDepartmentName',
    //   changeMethod: ctx.changeDepartmentHandler,
    // },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      // disabled: true,
      disabled: true,
    },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'searchTableSpec',
    //   searchType: 'contractMultipleProduct',
    //   extraData: {
    //     contractCategory: 'sales',
    //     companyCode: ctx.baseFormData.settlementCompanyNo,
    //     departmentCode: ctx.baseFormData.settlementDepartmentNo,
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeContractMethod,
    //   currentValue: ctx.baseFormData?.contractNo,
    //   disabled: true,
    // },
    {
      name: '客户名称',
      prop: 'customerName',
      type: 'input',
      // disabled: true,
      disabled: true,
    },
    // {
    //   name: '客户名称',
    //   prop: 'customerName',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   extraData: {
    //     companyCode: ctx.baseFormData.settlementCompanyNo,
    //     departmentCode: ctx.baseFormData.settlementDepartmentNo,
    //     partnerTypes: 'HZHB01',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeCustomsMethod,
    //   currentValue: ctx.baseFormData?.customerName,
    //   // disabled: true,
    //   disabled: true,
    // },
    {
      name: '订单编号',
      prop: 'orderCode',
      disabled: true,
      type: 'input',
      // placeholder: '自动生成',
    },
    {
      name: '币种',
      prop: 'currencyCode',
      type: 'ajaxSelect',
      apiUrl: BASEAPI.LIST_CURRENCY,
      clearable: true,
      filterable: true,
      valueKey: 'currencyCode',
      labelKey: 'currencyName',
      changeMethod: 'changeCurrencyHandler',
      method: 'get',
      valueType: 'object',
      // disabled: true,
      disabled: true,
    },
    {
      name: '汇率',
      prop: 'exchangeRate',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      disabled: true,
      // disabled: true,
    },
    {
      name: '产品',
      prop: 'productType',
      type: 'select',
      // type: 'input',
      options: ctx.productList,
      disabled: true,
    },
    {
      name: '服务',
      prop: 'serviceType',
      type: 'select',
      // type: 'input',
      options: ctx.serviceAllList,
      disabled: true,
    },
    {
      name: '创建方式',
      prop: 'createMethod',
      type: 'select',
      options: [
        {
          label: '系统',
          value: '01',
        },
        {
          label: '手动',
          value: '02',
        },
      ],
      disabled: true,
    },
    {
      name: '费用类型',
      prop: 'expenseTypeName',
      type: 'input',
      // type: 'select',
      // options: ctx.expenseTypeList,
      disabled: true,
    },
    {
      name: '应收账期',
      prop: 'accountPeriod',
      format: 'yyyy-MM',
      type: 'date',
      disabled: true,
    },
    {
      name: '费用生成日期',
      prop: 'expenseGenerationDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '指令下发日期',
      prop: 'instructionIssueDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '对账单编号',
      prop: 'settlementNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '异常费用',
      prop: 'abnormalExpenseFlag',
      type: 'select',
      options: [
        {
          label: '否',
          value: '0',
        },
        {
          label: '是',
          value: '1',
        },
      ],

      disabled: true,
    },
    {
      name: '确认状态',
      prop: 'confirmStatus',
      type: 'select',
      options: [
        {
          label: '待确认',
          value: '01',
        },
        {
          label: '已确认',
          value: '02',
        },
      ],
      disabled: true,
    },

    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
      disabled: true,
    },
    {
      name: '业务人员',
      prop: 'salesmanName',
      type: 'input',
      disabled: true,
    },
    // {
    //   name: '业务人员',
    //   prop: 'salesmanName',
    //   type: 'searchTableSpec',
    //   searchType: 'personnel',
    //   isMultiple: true,
    //   changeMethod: ctx.changePersonnelMethod,
    //   currentValue: ctx.baseFormData?.salesmanName,
    //   // disabled: true,
    //   disabled: true,
    // },
  ];
};

export const formRules = {
  // settlementCompanyNo: [{ required: true, message: '公司名称必填', trigger: 'change' }],
  // settlementDepartmentNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  // customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  // abnormalExpenseFlag: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementType: [{ required: true, message: '必填字段', trigger: 'change' }],
  // currencyCode: [{ required: true, message: '必填字段', trigger: 'change' }],
  // exchangeDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  // salesmanName: [{ required: true, message: '必填字段', trigger: 'change' }],
  // weaveName: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementBusinessType: [{ required: true, message: '必填字段', trigger: 'change' }],
  // receivableAccountPeriod: [{ required: true, message: '必填字段', trigger: 'change' }],
  // contractNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  // exchangeRate: [{ required: true, message: '必填字段', trigger: 'blur' }],
};

export const editFormRules = {
  // settlementStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementCreateDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  // statementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // receiveStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // invoiceAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
  // collectedAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
};

// 暴露出去
import API from '@/api/intermodality/order';
export default {
  // mixins: [tradeMixin],
  data() {
    return {
      formRules,
      baseFormData: {
        // settlementCompanyNo: '',
        // settlementCompanyName: '',
        // settlementDepartmentNo: '',
        // settlementDepartmentName: '',
        businessCompanyName: '',
        businessDepartmentName: '',
        customerName: '',
        customerNo: '',
        productType: '',
        serviceType: '',
        createMethod: '',
        expenseType: '',
        expenseTypeName: '',
        accountPeriod: '',
        expenseGenerationDate: '',
        instructionIssueDate: '',
        confirmStatus: '',
        businessDocCode: '',
        expenseNo: '',
        contractNo: '',
        abnormalExpenseFlag: '',
        currencyCode: '',
        currencyName: '',
        exchangeRate: '',
        processStatus: '',
        salesmanNo: '',
        salesmanName: '',
        settlementNo: '',
      },
      productList: [],
      serviceAllList: [],
      expenseTypeList: [],
      isCreate: true,
    };
  },
  watch: {
    // 'baseFormData.settlementDate': {
    //   deep: true,
    //   handler: function (newV) {
    //     console.log('watch中：', newV);
    //     this.baseFormData.receivableAccountPeriod = newV;
    //   },
    // },
  },
  computed: {
    formColumn() {
      return formFields(this);
    },
    baseFormRules() {
      if (this.isCreate) {
        return formRules;
      } else {
        return { ...formRules, ...editFormRules };
      }
    },
  },
  methods: {
    // 切换公司
    changeCompanyHandler(val) {
      console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        settlementCompanyNo: val,
        settlementCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      console.log(val, '切换部门');
      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: val,
        settlementDepartmentName: item.personDepartmentName,
      };
    },
    // 修改客户
    changeCustomsMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        customerName: rowData?.partnerZhName,
        customerNo: rowData?.partnerCode,
      };
    },
    // 修改合同
    changeContractMethod(val) {
      const rowData = val[0];
      console.log(rowData, 'rowData');
      this.baseFormData = {
        ...this.baseFormData,
        contractNo: rowData?.contractNo,
        customerName: rowData?.customerName,
        customerNo: rowData?.customerNo,
        projectInitiationNo: rowData?.projectInitiationNo,
        exchangeRate: rowData?.contractCurrencyExchangeRate
          ? rowData?.contractCurrencyExchangeRate + ''
          : '1',
        currencyCode: rowData?.contractCurrency,
        currencyName: rowData?.contractCurrencyName,
      };
      if (rowData.orderDetailList && rowData.orderDetailList.length) {
        this.productList = [];
        rowData.orderDetailList.map((item) => {
          if (item.contractMatterName && item.contractMatter) {
            this.productList.push({
              label: item.contractMatterName,
              value: item.contractMatter,
            });
          }
        });
      }
    },
    // 修改业务员
    changePersonnelMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        salesmanNo: rowData?.personNo,
        salesmanName: rowData?.personName,
      };
    },

    // 切换货币
    changeCurrencyHandler({ val }) {
      this.baseFormData = {
        ...this.baseFormData,
        currencyCode: val?.currencyCode,
        currencyName: val?.currencyName,
      };
      this.$emit('changeCurrencyHandler', val);
    },
    // 产品列表
    getProductList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-PRODUCT-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.productList = res.data.data || [];
            console.log(res.data.data, '产品');
          }
        });
    },
    // 服务列表
    getServiceList() {
      this.$axios
        .post(API.DATA_DICT, {
          dictType: 'INTERMODALITY-SERVICE-TYPE',
          tenantCode: this.userInfo.tenantCode,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.serviceAllList = res.data.data || [];
            console.log(res.data.data, '服务');
          }
        });
    },
  },
  mounted() {
    this.getProductList();
    this.getServiceList();
    // this.expenseTypeList = this.dictListMap?.expenseType.filter(
    //   (item) => item.remark == '多式联运'
    // );
    // this.isCreate = ['create', 'edit'].includes(this.$route.query?.status);
  },
};
